import styled from 'styled-components';

import {colors, font} from 'theme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 8px 8px;
`;

export const BackButton = styled.button`
    width: fit-content;
    background: transparent;
    border: 0;
    padding: 0;
    color: ${colors.brandPrimary};
    cursor: pointer;
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
`;

export const Title = styled.h3`
    margin: 0;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
`;

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const FieldLabel = styled.span`
    display: inline-block;
    margin: 0 0 6px;
    color: ${colors.textSecondary};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;
`;

export const RequiredMark = styled.span`
    color: ${colors.danger};
`;

export const BrandOwnerCheckbox = styled.div<{$checked: boolean}>`
    border: 1px solid ${(p) => (p.$checked ? colors.brandPrimary : colors.border)};
    border-radius: 8px;
    background: ${colors.white};
    padding: 12px;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    label {
        align-items: flex-start;
    }
`;

export const WarningBox = styled.div`
    border: 1px solid #ffa726;
    border-radius: 8px;
    background: #fff4e6;
    padding: 12px;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;

    p {
        margin: 0;
    }
`;

export const WarningTitle = styled.p`
    font-weight: 600;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    > * {
        width: auto;
        min-width: 128px;
    }
`;
